import React, {useEffect} from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import {getOrderResult} from '../api';
import getOrderDate from '../utils/getOrderDate';
import CircularProgress from '@material-ui/core/CircularProgress';
import makeStyles from '@material-ui/core/styles/makeStyles';

export interface ILoadOrderResult {
  id: number,
  unmountComponent: () => void,
  date: string,
  open: boolean,
}

const useStyles = makeStyles({
  DialogContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 16,
    color: '#666',
    padding: 20,
    '& > *': {
      margin: '0 10px'
    }
  }
});

const LoadOrderResultDialog = ({id, date, open, unmountComponent}: ILoadOrderResult): React.ReactElement => {
  const cl = useStyles();
  const handleOrderResult = async () => {


    const result = await getOrderResult(id);
    if (result instanceof Error) return unmountComponent();
    const name = getOrderDate(date) + '_order_result.pdf';
    const url = window.URL.createObjectURL(new Blob([result], {type: 'application/pdf'}));
    if (open) {
      const link = document.createElement('a');
      link.href = url
      document.body.appendChild(link);
      link.click();
      link.remove();
    } else {
       window.open(url );
    }

    unmountComponent();
  };


  useEffect(() => {
    handleOrderResult();
  }, []);
  return (
    <Dialog
      open={true}
    >
      <DialogContent className={cl.DialogContent}>
        <CircularProgress size={36}/> завантаження результатів.
      </DialogContent>
    </Dialog>
  );
};

export default LoadOrderResultDialog;
